import { Step } from '@/service/parkings'

import { Container, ToggleViewButton } from './ToggleView.styled'

interface Props {
  className?: string
  views: Step[]
  active: number
  toggleView(view: number): void
}

function ToggleView(props: Props) {
  const { className, toggleView, views, active } = props

  return (
    <Container className={className}>
      {views.map((view, index) => (
        <ToggleViewButton
          key={index}
          active={active === index}
          onClick={() => toggleView(index)}
          as="button"
        >
          {view?.title}
        </ToggleViewButton>
      ))}
    </Container>
  )
}

export default ToggleView
